import { Box, Button, Icon, type MediumIcon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

interface Props {
  icon: MediumIcon
  title: string
  description: string
  buttonText: string
  employeeId: string
  contractVersionId: string
}

const Blank = ({ icon, title, description, buttonText, employeeId, contractVersionId }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Box
      gridColSpan={{ xxs: 12 }}
      padding="s24"
      justifyContent="center"
      alignItems="center"
      gap="s16"
      width="full"
    >
      <Icon.Medium icon={icon} />
      <Box textAlign="center" gap="s4">
        <Text.Normal color="grey1000" weight="semibold" size="300">
          {title}
        </Text.Normal>
        <Text.Normal color="grey800" weight="normal" size="200">
          {description}
        </Text.Normal>
      </Box>
      <Box paddingTop="s16">
        <Button.Router
          type="secondary"
          to={navigation.employees.id.contractVersions.fix.fullPath({
            id: employeeId.toString(),
            contractVersionId: contractVersionId.toString(),
          })}
        >
          {buttonText}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default Blank
